import { render, staticRenderFns } from "./vpayWithdrawal.vue?vue&type=template&id=77aed97e&scoped=true"
import script from "./vpayWithdrawal.vue?vue&type=script&lang=js"
export * from "./vpayWithdrawal.vue?vue&type=script&lang=js"
import style0 from "./vpayWithdrawal.vue?vue&type=style&index=0&id=77aed97e&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77aed97e",
  null
  
)

export default component.exports